import { Component } from '@angular/core';

@Component({
  selector: 'era-mdm',
  templateUrl: './mdm.component.html',
})
export class MdmComponent {}
